module.exports = [
  require('./type'),        // data types (Matrix, Complex, Unit, ...)
  require('./constants'),   // constants
  require('./expression'),  // expression parsing
  require('./function'),    // functions
  require('./json'),        // serialization utility (math.json.reviver)
  require('./error')        // errors
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/index.js
// module id = 900
// module chunks = 0